import React, { useState, useEffect } from "react";
import { Typography, Box, Button, Divider } from "@mui/material";
import { useAppSelector } from "../../../hooks";
import Icon_printer from "../../../assets/Icon_printer.svg";
import { useNavigate } from "react-router";
import { calculateRemainingBalance, chatClick, getBanWithMasking, getServiceAddressId } from "../../../Utils/utils";
import { formatDate, formatDateToMMDDYYYY} from "../../../Utils/dateFormatter";
import user from "../../../SharedContextStore/slices/user";
import planDetails from "../../../SharedContextStore/slices/planDetails";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";
import { useCustomNavigate } from "../../../Utils/navigationUtils";
interface alreadyOnPaymentScheduleProps {
  onClose: any;
  planDetials:any;
  modalRenderedRef?:any;
}

function AlreadyOnPaymentSchedule(props: alreadyOnPaymentScheduleProps) {
 const {modalRenderedRef}=props;
  const {customNavigate} = useCustomNavigate();
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
    const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
  const navigate = useNavigate();
  const notEligiblePaymentSchedule = JSONcontent?.notEligibleDueToPaymentSchedule;
  const paymentHistoryForPA = useAppSelector((state) => state.paymentHistoryForPA);
  const user = useAppSelector((state) => state.user.data);
  const AddressId=getServiceAddressId(user?.addresses);
  const notEligiblePaymentScheduleJSON = JSONcontent?.notEligibleDueToPaymentSchedule;
  const PALandingPageJSON = JSONcontent?.paymentArrangementLandingPage;
  const remainingBalance= paymentHistoryForPA && calculateRemainingBalance(paymentHistoryForPA);
  

  return (
    <Box className="nonAuthEligibleModalBox">
      <Typography className="nonAuthEligibleModalTitle" component="h2" id="scroll-dialog-title">
        {notEligiblePaymentSchedule?.title}
      </Typography>
      <div 
      // id="scroll-dialog-description"
      >
      <Typography className="nonAuthEligibleModalDescription" >
        {notEligiblePaymentSchedule?.cannotSetupPayment}{" "}
        {/* <a className="blackColorLinkText" target="_blank" href="#" onClick={(e) => { e.preventDefault();  chatClick(); }}>
          {notEligiblePaymentSchedule?.chatUs}
        </a> */}
      </Typography>

      <Typography className="nonAuthEligibilityModalSubTitle" component="h2">
        {notEligiblePaymentSchedule?.paymentArrangementDetails}
      </Typography>
      <Box className="nonAuthEligibilitymodalLine"></Box>

      <Box className="DisplayflexofDirectionRow">
        <Typography className="nonAuthEligibilityAccNumberlabel" component="label">
          {notEligiblePaymentSchedule?.accountNumber}&nbsp;
        </Typography>
        <Typography className="nonAuthEligibilityAccNumber" component="label">
        <b>{getBanWithMasking(paymentHistoryForPA?.paymentHistory?.ban)}</b>
        </Typography>
      </Box>

      <Typography className="nonAuthEligibilityModalSubTitleSecond" component="h3">
        {notEligiblePaymentSchedule?.paymentSchedule}
      </Typography>

      <Box className="paymentScheduleDetails">
        {paymentHistoryForPA && paymentHistoryForPA?.paymentHistory?.treatment?.map((item: any) => (
          item?.installment?.map((item1: any,index:any) => (
            <Box key={item1.date} className="DisplayflexofDirectionRowSpaceBetween text-color-secondary">
              <Box className="PartitionSmallSide">
                <Typography className="nonAuthEligibilityModalDesc font-secondary" component="label" style={{display:"block"}}>
                  {item1?.status?.toUpperCase() === "PAID" ?
                   "Payment received" :`${"Installment"} ${index + 1}`  }
                </Typography>
                <Typography className="nonAuthEligibilityModalDate font-secondary" component="label">
                  { formatDate(item1?.date) }
                </Typography>
              </Box>
              <Typography className="PartitionBigSide font-secondary" component="label">
              {
               item1?.status?.toUpperCase() === "PAID" 
               ? `($${item1?.amount})` 
               : index > 1  
               ? `$${item1?.amount} `
               : `$${item1?.amount} `  
               }
               </Typography>
            </Box>
          ))
        ))}
      </Box>

      <Box className="DisplayflexofDirectionRowSpaceBetweenBottom">
        <Box>
          <Typography className="nonAuthEligibilityModalSubTitleSecond">
            {notEligiblePaymentSchedule?.remainingBalance}
          </Typography>
        </Box>
        <Typography className="nonAuthEligibilityModalSubTitleSecond">
          {paymentHistoryForPA?.paymentHistory?.totalDueAmount === undefined ? "$0.00" : `$${paymentHistoryForPA?.paymentHistory?.totalDueAmount}`} 
         {/* {`${remainingBalance}`} */}
        </Typography>
      </Box>
      <Typography className="nonAuthEligibilityModalRequiredMessage">
        {notEligiblePaymentSchedule?.installmentsWithMonthlyBill}
      </Typography>
      <Box
        className="DisplayflexofDirectionRowprint noPrint"
        onClick={() => window.print()}
      >
        <img src={Icon_printer} />
        &nbsp;&nbsp;
        <Typography>
          <a className="blackColorLinkText" href="">
            {notEligiblePaymentSchedule?.printLabel}
          </a>
        </Typography>
      </Box>
   

      <Box className="buttonBoxContainer noPrint">
        <Button
          variant="outlined"
          color="primary"
          // onClick={}
          className="secondary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
          onClick={() =>
            window.open(
              process.env.REACT_APP_URL,
              "_blank",
              "noopener, noreferrer"
            )
          }
        >
          {notEligiblePaymentSchedule?.signInButton }
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="primary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
          onClick={() => {
            props.onClose();
            customNavigate(`/agent-quick-bill-pay?accountId=${props?.planDetials?.data?.billingAccountNumber}&addressId=${props?.planDetials?.data?.addressId}&flow=AMQBP`);
          }}
        >
          {notEligiblePaymentSchedule?.makePaymentButton}
        </Button>
      </Box>
      
      <Divider sx={{ height: "2px", mt: "40px",mb:"32px" }} role="presentation"/>
      <Box>
        <Typography className="needhelpPaymentArrangement" component="h3">
          {PALandingPageJSON?.helpLabel}
        </Typography>
        <Typography
        className="learnMorePaymentArrangement"
        component="a"
        href={PALandingPageJSON?.learnMoreHref}
        target="_blank"
        >
          {PALandingPageJSON?.learnMore}
        </Typography>
      </Box>
      </div>
    </Box>
 
  );
}

export default AlreadyOnPaymentSchedule;
